/** Applies one brush dab to a mask in place. "erase" pushes alpha toward 0, "restore" toward 255. */
export function applyBrushDab(mask, stroke) {
    const { x, y, radius, hardness, mode } = stroke;
    if (radius <= 0)
        return;
    const target = mode === 'erase' ? 0 : 255;
    const minX = Math.max(0, Math.floor(x - radius));
    const maxX = Math.min(mask.width - 1, Math.ceil(x + radius));
    const minY = Math.max(0, Math.floor(y - radius));
    const maxY = Math.min(mask.height - 1, Math.ceil(y + radius));
    const hardRadius = radius * Math.min(Math.max(hardness, 0), 1);
    for (let py = minY; py <= maxY; py++) {
        for (let px = minX; px <= maxX; px++) {
            const dx = px - x;
            const dy = py - y;
            const dist = Math.sqrt(dx * dx + dy * dy);
            if (dist > radius)
                continue;
            let strength;
            if (dist <= hardRadius) {
                strength = 1;
            }
            else {
                const falloffRange = radius - hardRadius;
                strength = falloffRange > 0 ? 1 - (dist - hardRadius) / falloffRange : 0;
            }
            const idx = py * mask.width + px;
            const current = mask.alpha[idx];
            mask.alpha[idx] = Math.round(current + (target - current) * strength);
        }
    }
}
/** Interpolates dabs along a drag path so fast strokes don't leave gaps. */
export function applyBrushStroke(mask, from, to, radius, hardness, mode) {
    const dx = to.x - from.x;
    const dy = to.y - from.y;
    const distance = Math.sqrt(dx * dx + dy * dy);
    const step = Math.max(1, radius / 4);
    const steps = Math.max(1, Math.ceil(distance / step));
    for (let i = 0; i <= steps; i++) {
        const t = i / steps;
        applyBrushDab(mask, { x: from.x + dx * t, y: from.y + dy * t, radius, hardness, mode });
    }
}
//# sourceMappingURL=brush.js.map